// Components
import {
  Section,
  SectionSkeleton,
  Box,
  Radio,
} from '@zolteam/zol-admin-ui';

/**
 * Format in a phrase the time difference between now and a given date.
 * @param {Date} date
 * @param {string} locale
 * @returns {string}
 */
const formatTimeDifference = (date, locale) => {
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  const now = new Date();
  const diffInSeconds = Math.floor((date.getTime() - now.getTime()) / 1000);
  const absDiffInSeconds = Math.abs(diffInSeconds);

  if (absDiffInSeconds < 60) {
    return rtf.format(diffInSeconds, 'second');
  } if (absDiffInSeconds < 3600) {
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    return rtf.format(diffInMinutes, 'minute');
  } if (absDiffInSeconds < 86400) {
    const diffInHours = Math.floor(diffInSeconds / 3600);
    return rtf.format(diffInHours, 'hour');
  }
  const diffInDays = Math.floor(diffInSeconds / 86400);
  return rtf.format(diffInDays, 'day');
};

/**
 * ContentTranslationHistory component.
 * @param {object} props
 * @param {boolean} [props.isLoading=false]
 * @param {Array<ContentTranslationDataVersion> | undefined | null} props.contentTranslationVersions
 * @param {Function} props.onVersionChange
 * @param {string} props.sectionTitle
 * @param {string} props.currentVersionLabel
 * @param {string} props.sectionInstructionlabel
 * @param {number | null} props.selectedVersion
 * @returns {JSX.Element}
 */
function ContentTranslationHistory({
  isLoading = false,
  contentTranslationVersions,
  onVersionChange,
  selectedVersion,
  sectionTitle,
  currentVersionLabel,
  sectionInstructionlabel,
}) {
  return isLoading
    ? <SectionSkeleton />
    : (
      <Section id="versions-section" title={sectionTitle} isDisplay={!!contentTranslationVersions?.length}>
        <ul>
          {contentTranslationVersions?.map((version, index) => (
            <li key={version.timestamp}>
              <Box
                direction="row"
                justify="space-between"
                align="center"
              >
                <Radio
                  size="small"
                  id={version.timestamp.toString()}
                  label={!index ? currentVersionLabel : formatTimeDifference(new Date(version.timestamp * 1000), 'fr')}
                  checked={selectedVersion ? selectedVersion === version.timestamp : index === 0}
                  onChange={() => onVersionChange(version)}
                />
              </Box>
            </li>
          ))}
        </ul>
        <span className="p2-default font-color-neutral-500">
          {sectionInstructionlabel}
        </span>
      </Section>
    );
}

export default ContentTranslationHistory;
